<template>
  <div>
    <b-container class="mb-4">
      <b-form-row>
        <b-col>
          <label for="company" v-translate>For Company</label>
          <company-autocomplete v-if="!company" ref="companyAc" @selected="setRentalOrderCompany" :includes="['country']" />
          <b-card v-if="company">
            <span v-if="!fleetRentalOrder.id" class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="resetData();">×</span>
            <company-card :company="company" profilePictureSize="110px" />
          </b-card>
        </b-col>
      </b-form-row>
      <form @submit.prevent="saveOrder" v-if="fleetRentalOrder.company_id">
        <div>
          <b-row>
            <b-col>
              <b-form-group>
                <label for="reference" v-translate>Reference</label>
                <b-input-group>
                  <b-form-input v-model="fleetRentalOrder.reference" type="text" size="lg"></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <label for="region" v-translate>Region</label>
                    <b-input-group>
                      <b-form-select v-if="regionsSelect && automaticRegion !== undefined" v-model="fleetRentalOrder.region_id" :options="regionsSelect" :disabled="!!(fleetRentalOrder.place_id && fleetRentalOrder.region_id && automaticRegion)">
                        <template #first>
                          <option :value="null"><translate>Select</translate></option>
                        </template>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <label for="agreed-price" v-translate>Agreed Price</label>
                    <b-input-group>
                      <b-form-input v-model="fleetRentalOrder.agreed_price" type="number" step="0.01" required></b-form-input>
                      <template #append>
                        <b-input-group-text>{{fleetRentalOrder.currency || '-'}}</b-input-group-text>
                      </template>
                    </b-input-group>
                    <b-form-text v-if="fleetRentalOrder.meta.serviceDefinition && fleetRentalOrder.meta.serviceDefinition.unitPrice && fleetRentalOrder.meta.serviceDefinition.quantity" v-translate="{price: fleetRentalOrder.meta.serviceDefinition.unitPrice * fleetRentalOrder.meta.serviceDefinition.quantity || '', currency: fleetRentalOrder.currency || ''}">Estimated client price: %{price} %{currency}</b-form-text>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label for="agreed-price" v-translate>Final Price</label>
                    <b-input-group>
                      <b-form-input v-model="fleetRentalOrder.price" type="number" step="0.01"></b-form-input>
                      <template #append>
                        <b-input-group-text>{{fleetRentalOrder.currency || '-'}}</b-input-group-text>
                      </template>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <label for="amount-requested" v-translate>Vehicles Amount Requested</label>
                    <b-input-group>
                      <b-form-input v-model="fleetRentalOrder.amount_requested" type="number" :min="fleetRentalOrder.fleet_rental_order_vehicles.length" :formatter="setMinMaxVehicles" required></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label for="status" v-translate>Status</label>
                    <b-input-group>
                      <b-form-select v-model="fleetRentalOrder.status" :options="fleetRentalOrderStatuses" :disabled="fleetRentalOrder.status === 'incidence' && !isFleetAdmin"></b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-group>
                <label for="search-origin-address" v-translate>Origin Address</label>
                <address-autocomplete id="search-origin-address" v-if="!fleetRentalOrder.place_id" @selected="setfleetRentalOrderPlaceId" static-items :minCharacter="4" class="mb-2" />
                <p v-else>
                  {{place.formatted_address}}
                  <b-badge variant="danger" href="#" @click.prevent="place.formatted_address = ''; fleetRentalOrder.place_id = null; fleetRentalOrder.region_id = null; automaticRegion = false">×</b-badge>
                </p>
              </b-form-group>
              <b-form-group>
                <label for="change-status" v-translate>Time Range</label>
                <b-input-group>
                  <date-range-picker
                    v-if="this.locale.daysOfWeek"
                    v-model="updatedDateRange"
                    :locale-data="locale"
                    :opens="opens"
                    class="mb-2 w-100"
                    :ranges="ranges"
                    @update="updateValues"
                    time-picker
                    :time-picker-increment="15"
                    ref="dateRange"
                    @click="resetUpdatedDateRange"
                    single-date-psicker
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span style="vertical-align: middle">{{moment(updatedDateRange.startDate).format('L LT')}}</span>
                      -
                      <span style="vertical-align: middle">{{moment(updatedDateRange.endDate).format('L LT')}}</span>
                    </div>
                  </date-range-picker>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <label for="reference" v-translate>Instructions</label>
                <b-input-group>
                  <b-form-textarea v-model="fleetRentalOrder.instructions"></b-form-textarea>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6" v-if="fleetRentalOrder.meta.serviceDefinition">
              <h4 v-translate>About the service</h4>
              <b-form-group>
                <label for="reference" v-translate>Unit Type</label>
                <b-input-group>
                  <b-form-select v-model="fleetRentalOrder.meta.serviceDefinition.unitType" :options="unitTypes"></b-form-select>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <label for="reference" v-translate>Unit Price</label>
                <b-input-group>
                  <b-form-input v-model="fleetRentalOrder.meta.serviceDefinition.unitPrice" type="number"></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <label for="reference" v-translate>Quantity</label>
                <b-input-group>
                  <b-form-input v-model="fleetRentalOrder.meta.serviceDefinition.quantity" type="number"></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <label for="reference" v-translate>Generic Courier Commission Percentage</label>
                <b-input-group>
                  <b-form-input v-model="fleetRentalOrder.meta.serviceDefinition.commissionPercentage" type="number"></b-form-input>
                  <template #append>
                    <b-input-group-text>%</b-input-group-text>
                  </template>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-button type="submit" v-translate>Save Order</b-button>
      </form>
    </b-container>
    <b-row v-if="fleetRentalOrder.id">
      <b-col>
        <h4>
          <translate>Vehicles</translate>
          <small><small :class="'text-' + (fleetRentalOrder.fleet_rental_order_vehicles.filter(x => x.courier_id !== null).length === 0 ? 'danger' : (fleetRentalOrder.fleet_rental_order_vehicles.filter(x => x.courier_id !== null).length < fleetRentalOrder.amount_requested ? 'warning' : 'success'))" v-translate="{fulfilled: fleetRentalOrder.fleet_rental_order_vehicles.filter(x => x.courier_id !== null).length, requested: fleetRentalOrder.amount_requested}">
            (Fulfilled %{fulfilled}/%{requested})
          </small></small>

          <b-button size="sm" class="p-0 px-1" :variant="!fleetRentalOrder.meta || !fleetRentalOrder.meta.serviceDefinition ? 'dark' : (fleetRentalOrder.fleet_rental_order_vehicles.reduce((n, {meta}) => { return n + (meta && meta.serviceDetail && meta.serviceDetail.quantity ? parseInt(meta.serviceDetail.quantity) : 0) }, 0) === 0 ? 'danger' : (fleetRentalOrder.fleet_rental_order_vehicles.reduce((n, {meta}) => { return n + (meta && meta.serviceDetail && meta.serviceDetail.quantity ? parseInt(meta.serviceDetail.quantity) : 0) }, 0) < fleetRentalOrder.meta.serviceDefinition.quantity ? 'warning' : 'success'))" id="tooltip-target-general">
            <small>
              <font-awesome-icon :icon="['far', 'eye']" />
              <span v-translate>Service Details</span>
            </small>
          </b-button>
          <b-tooltip target="tooltip-target-general" triggers="hover">
            <div style="min-width: 250px" class="text-left">
              <dl v-if="fleetRentalOrder.meta && fleetRentalOrder.meta.serviceDefinition">
                <dt v-translate>Service Type</dt>
                <dd>{{ unitTypes.find(x => x.value === fleetRentalOrder.meta.serviceDefinition.unitType).text || $gettext('Generic') }}</dd>
                <dt v-translate>Service Quantity/Assigned</dt>
                <dd>{{ fleetRentalOrder.fleet_rental_order_vehicles.reduce((n, {meta}) => { return n + (meta && meta.serviceDetail && meta.serviceDetail.quantity ? parseInt(meta.serviceDetail.quantity) : 0) }, 0) }}/{{ fleetRentalOrder.meta.serviceDefinition.quantity }}</dd>
              </dl>
              <p class="mb-0" v-else v-translate>Service Details not defined</p>
            </div>
          </b-tooltip>
        </h4>
        <fleet-rental-order-vehicle-list :fleet-rental-order="fleetRentalOrder" :fleet-rental-order-vehicles="vehicles" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import AddressAutocomplete from '@/components/autocompletes/AddressAutocomplete'
import DateRangePicker from 'vue2-daterange-picker'
import FleetRentalOrderVehicleList from '@/components/FleetRentalOrderVehicleList'

export default {
  name: 'FleetRentalOrderForm',
  components: {
    CompanyAutocomplete,
    AddressAutocomplete,
    DateRangePicker,
    FleetRentalOrderVehicleList
  },
  props: {
    fleetRentalOrder: {
      type: Object,
      default: () => {
        return {
          id: null,
          agreed_price: null,
          amount_requested: 0,
          company_id: null,
          currency: null,
          date_from: null,
          date_to: null,
          instructions: null,
          meta: {
            serviceDefinition: {
              unitType: 'generic',
              unitPrice: 0,
              quantity: null,
              commissionPercentage: 60
            },
            country_iso_code: null
          },
          region_id: null,
          place_id: null,
          place: {},
          price: null,
          reference: null,
          status: 'pending',
          fleet_rental_order_vehicles: []
        }
      }
    },
    staticCompany: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      company: null,
      place: {},
      fleetRentalOrderStatuses: [
        {
          text: this.$gettext('Pending'),
          value: 'pending'
        },
        {
          text: this.$gettext('Assigned'),
          value: 'assigned'
        },
        {
          text: this.$gettext('Confirmed'),
          value: 'confirmed'
        },
        {
          text: this.$gettext('Incidence'),
          value: 'incidence'
        }
      ],
      unitTypes: [
        {
          text: this.$gettext('Generic'),
          value: 'generic'
        },
        {
          text: this.$gettext('Weight (Tons)'),
          value: 'weightTons'
        },
        {
          text: this.$gettext('Weight (Kgs)'),
          value: 'weightKgs'
        },
        {
          text: this.$gettext('Guides'),
          value: 'guides'
        },
        {
          text: this.$gettext('Routes'),
          value: 'routes'
        }
      ],
      updatedDateRange: { // used for v-model prop
        startDate: this.moment.utc().tz(this.$tz).seconds(0).toISOString(true),
        endDate: this.moment.utc().tz(this.$tz).add(1, 'hour').seconds(0).toISOString(true)
      },
      opens: 'left', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {
        direction: 'ltr', //  direction of text
        format: 'yyyy-mm-dd\'T\'HH:MM:ss\'Z\'', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      },
      ranges: false,
      updatedDateRangeActive: 0,
      vehicles: [],
      vehicle: {
        reference: null,
        vehicle_id: null,
        vehicle: null,
        courier_id: null,
        courier: null,
        commission: 0,
        instructions: null,
        meta: {
          serviceDetail: {
            items: [],
            quantity: 0
          }
        },
        place_id: null,
        place: null,
        status: 'pending'
      },
      selectedVehicle: undefined,
      automaticRegion: undefined
    }
  },
  watch: {
    updatedDateRange: {
      handler (val) {
        if (this.updatedDateRangeActive !== 0) {
          this.fleetRentalOrder.date_from = this.moment(val.startDate).seconds(0).utc().format('YYYY-MM-DD HH:mm:ss')
          this.fleetRentalOrder.date_to = this.moment(val.endDate).seconds(0).utc().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.fleetRentalOrder.date_from = null
          this.fleetRentalOrder.date_to = null
        }
      },
      deep: true
    },
    fleetRentalOrder: {
      handler (val, oldVal) {
        if (val.id && !oldVal.id) { // just one time if updating
          if (val.company) {
            this.setRentalOrderCompany(val.company)
          }
          if (val.date_from) {
            this.updatedDateRange = { // used for v-model prop
              startDate: this.moment.utc(val.date_from).tz(this.$tz).seconds(0).toISOString(true),
              endDate: this.moment.utc(val.date_to).tz(this.$tz).seconds(0).toISOString(true)
            }
            this.updatedDateRangeActive = 1
          }
          if (val.place) {
            this.place = {...val.place}
          }
          this.automaticRegion = !!(this.fleetRentalOrder.place_id && this.fleetRentalOrder.region_id)
        }
        let notDefinedVehicles = []
        if (!val.fleet_rental_order_vehicles || val.fleet_rental_order_vehicles.length < val.amount_requested) {
          for (let i = 1; i <= (val.amount_requested - val.fleet_rental_order_vehicles.length); i++) {
            notDefinedVehicles.push({...JSON.parse(JSON.stringify(this.vehicle)), currency: val.currency, fleet_rental_order_id: val.id})
          }
        }

        this.vehicles = [...new Set(val.fleet_rental_order_vehicles.map(item => ({...item, isEdit: false}))), ...notDefinedVehicles.map(item => ({...item, isEdit: false}))]

        if (this.fleetRentalOrderStatuses.findIndex(x => x.value === 'canceled') === -1 && ((this.isFleet && this.vehicles.findIndex(x => x.status === 'incidence' || x.status === 'done') === -1) || this.isFleetAdmin)) {
          this.fleetRentalOrderStatuses.push({
            text: this.$gettext('Cancelled'),
            value: 'canceled'
          })
        }

        if (!val.meta) {
          this.fleetRentalOrder.meta = {
            serviceDefinition: {
              unitType: 'generic',
              unitPrice: 0,
              quantity: null,
              commissionPercentage: 60
            },
            country_iso_code: val.company.country_iso_code
          }
        }
      },
      deep: true
    }
  },
  mixins: [AddressMixins],
  created() {
    if (this.staticCompany) {
      this.company = this.staticCompany
      this.fleetRentalOrder.meta.country_iso_code = this.company.country_iso_code
    }
  },
  mounted () {
    this.fetchRegions()
      .then(() => {
        if (!this.fleetRentalOrder.id) {
          this.automaticRegion = false
        }
        if (this.fleetRentalOrder.company) {
          this.setRentalOrderCompany(this.fleetRentalOrder.company)
        }
        if (this.fleetRentalOrder.date_from) {
          this.updatedDateRange = { // used for v-model prop
            startDate: this.moment.utc(this.fleetRentalOrder.date_from).tz(this.$tz).seconds(0).toISOString(true),
            endDate: this.moment.utc(this.fleetRentalOrder.date_to).tz(this.$tz).seconds(0).toISOString(true)
          }
          this.updatedDateRangeActive = 1
        }
        if (this.fleetRentalOrder.place) {
          this.place = this.fleetRentalOrder.place
        }
        if (this.fleetRentalOrder.fleet_rental_order_vehicles && this.fleetRentalOrder.fleet_rental_order_vehicles.length > 0) {
          this.vehicles = JSON.parse(JSON.stringify(this.fleetRentalOrder.fleet_rental_order_vehicles))
        }
        if (this.isFleetAdmin) {
          this.fleetRentalOrderStatuses.push({
            text: this.$gettext('Finished'),
            value: 'finished'
          })
        }
      })
  },
  methods: {
    setRentalOrderCompany(item) {
      this.company = item
      this.fleetRentalOrder.company_id = item.id
      this.fleetRentalOrder.currency = item.country.currency
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    async setfleetRentalOrderPlaceId(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.place = this.theCheckedAddress
          this.fleetRentalOrder.place_id = this.theCheckedAddress.id
          if (this.theCheckedAddress.in_area && this.theCheckedAddress.in_area.regions[0]) {
            this.fleetRentalOrder.region_id = this.theCheckedAddress.in_area.regions[0].id
            this.automaticRegion = true
          }
        }
        this.theCheckedAddress = {}
      })
    },
    resetUpdatedDateRange() {
      if (this.updatedDateRangeActive === 0) {
        this.updatedDateRange = {
          startDate: this.moment().seconds(0).format('YYYY-MM-DD HH:mm:ss'),
          endDate: this.moment().seconds(0).format('YYYY-MM-DD HH:mm:ss')
        }
        this.updatedDateRangeActive = 0
      }
    },
    updateValues(obj) {
      this.updatedDateRangeActive++
      this.$refs.dateRange.$el.childNodes[0].className = this.$refs.dateRange.$el.childNodes[0].className.replace(' is-invalid', '')
    },
    setMinMaxVehicles(value) {
      return this.fleetRentalOrder.fleet_rental_order_vehicles.length > value ? this.fleetRentalOrder.fleet_rental_order_vehicles.length : (value <= 500 ? value : 500)
    },
    async saveOrder() {
      if (this.fleetRentalOrder.id) {
        this.$http.patch(this.$appConfig.api.baseUrl + 'fleet-rental-orders/' + this.$route.params.id, this.fleetRentalOrder)
          .then(response => {
            this.$parent.getItem()
          })
      } else {
        this.$http.post(this.$appConfig.api.baseUrl + 'fleet-rental-orders', this.fleetRentalOrder)
          .then(response => {
            this.$router.push({name: 'FleetRentalOrderEdit', params: {id: response.body.id}})
            window.location.reload()
          })
      }
      this.$emit('success', true)
    }
  }
}
</script>
